import { useState } from "react";
import Header from "@/components/Header";
import Sidebar from "@/components/Sidebar";
import Footer from "@/components/Footer";
import FixedMobileMenu from "@/components/FixedMobileMenu";

export default function MainLayout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(
    window.innerWidth >= 640 ? true : false,
  );

  return (
    <div id="main-layout">
      <Header onSidebarToggle={() => setSidebarOpen((open) => !open)} />
      <main className="relative flex flex-row items-center justify-center h-full sm:h-[var(--main-height)]">
        <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />
        <div
          id="main-content"
          className={`flex-1 h-full ${
            window.innerWidth <= 640
              ? sidebarOpen
                ? "overflow-hidden "
                : "overflow-y-auto"
              : "overflow-y-auto"
          } bg-aw-bgbluedark-30 scrollbar-box`}
        >
          <div>
            <div
              className={`relative flex flex-col items-center justify-start min-h-[var(--main-height)] p-2 duration-300 transition-all`}
            >
              <div
                className={`sm:hidden ${
                  sidebarOpen
                    ? "bg-black block opacity-30 w-full min-h-[var(--main-height)] absolute top-0 left-0 z-50"
                    : "hidden"
                }`}
                onClick={() => setSidebarOpen(!sidebarOpen)}
              ></div>
              {children}
            </div>
            <Footer />
          </div>
        </div>
      </main>
      <FixedMobileMenu />
    </div>
  );
}
